import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkAssignmentModal = ({ 
  isOpen, 
  onClose, 
  selectedOrders = [], 
  availableTechnicians = [], 
  onAssign 
}) => {
  const [assignmentMode, setAssignmentMode] = useState('manual');
  const [selectedTechnician, setSelectedTechnician] = useState('');
  const [optimizationCriteria, setOptimizationCriteria] = useState('workload');

  const assignmentModeOptions = [
    { value: 'manual', label: 'Manuell zuweisen' },
    { value: 'auto', label: 'Automatisch optimieren' }
  ];

  const optimizationOptions = [
    { value: 'workload', label: 'Arbeitsbelastung ausgleichen' },
    { value: 'skills', label: 'Fähigkeiten abgleichen' },
    { value: 'location', label: 'Entfernung minimieren' },
    { value: 'sla', label: 'SLA-Einhaltung priorisieren' }
  ];

  // Temporarily remove status filter to debug
  const technicianOptions = availableTechnicians?.map(tech => ({
      value: tech?.id,
      label: `${tech?.name}`
    }));
    

  const handleAssign = () => {
    if (assignmentMode === 'manual' && selectedTechnician) {
      const technician = availableTechnicians?.find(t => t?.id === selectedTechnician);
      onAssign(selectedOrders, [technician], 'manual');
    } else if (assignmentMode === 'auto') {
      onAssign(selectedOrders, availableTechnicians, 'auto', optimizationCriteria);
    }
    onClose();
  };

  const canAssign = () => {
    if (assignmentMode === 'manual') {
      return selectedTechnician && selectedOrders?.length > 0;
    }
    return selectedOrders?.length > 0 && availableTechnicians?.length > 0;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-1200">
      <div className="bg-card border border-border rounded-lg w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-lg font-semibold text-foreground">
            Mehrfachzuweisung
          </h2>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={20} />
          </Button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Selected Orders Summary */}
          <div className="bg-muted/50 rounded-lg p-3">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="ClipboardList" size={16} className="text-text-secondary" />
              <span className="text-sm font-medium text-foreground">
                {selectedOrders?.length} Aufträge ausgewählt
              </span>
            </div>
            <div className="text-xs text-text-secondary">
              {selectedOrders?.slice(0, 3)?.map(order => `#${order?.orderNumber}`)?.join(', ')}
              {selectedOrders?.length > 3 && ` und ${selectedOrders?.length - 3} weitere`}
            </div>
          </div>

          {/* Assignment Mode */}
          {/* <div>
            <Select
              label="Zuweisungsmodus"
              options={assignmentModeOptions}
              value={assignmentMode}
              onChange={setAssignmentMode}
            />
          </div> */}

          {/* Manual Assignment */}
          {assignmentMode === 'manual' && (
            <div>
              <Select
                label="Techniker auswählen"
                placeholder="Techniker auswählen..."
                searchable
                options={technicianOptions}
                value={selectedTechnician}
                onChange={setSelectedTechnician}
              />
            </div>
          )}

          {/* Auto Assignment */}
          {assignmentMode === 'auto' && (
            <div>
              <Select
                label="Optimierungskriterium"
                options={optimizationOptions}
                value={optimizationCriteria}
                onChange={setOptimizationCriteria}
              />
              <div className="mt-2 p-3 bg-accent/10 rounded-lg">
                <div className="flex items-start space-x-2">
                  <Icon name="Info" size={16} className="text-accent mt-0.5" />
                  <div className="text-sm text-accent">
                    Das System wird die Aufträge automatisch basierend auf dem gewählten Kriterium verteilen.
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Available Technicians Info */}
          {/* <div className="bg-muted/30 rounded-lg p-3">
            <div className="text-sm text-text-secondary">
              <strong>{availableTechnicians?.filter(t => t?.status === 'available')?.length}</strong> verfügbare Techniker
            </div>
          </div> */}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border">
          <Button variant="outline" onClick={onClose}>
            Abbrechen
          </Button>
          <Button
            variant="default"
            onClick={handleAssign}
            disabled={!canAssign()}
          >
            <Icon name="UserPlus" size={16} className="mr-2" />
            {assignmentMode === 'manual' ? 'Zuweisen' : 'Optimieren & Zuweisen'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkAssignmentModal;